<script>
    import {onDestroy, onMount} from 'svelte';
    import {PRConnect} from "@projectroom/ui-lib";
    import {navigateTo} from 'svelte-router-spa';
    import {fade} from 'svelte/transition';
    import Select from 'svelte-select';
    import axios from "axios";

	export let event;
	export let currentRoute;

	const RECEIVE_CONTENT = {
		"name" : "이름",
		"email" : "이메일",
		"phone" : "전화번호",
		"insta" : "인스타 주소"
	}

    class PageInfo {
        constructor({page=1, perPageNum=20, totalCount=100}) {
            this.totalCount = totalCount;
            this.setPage(page, perPageNum); 
        }

        setPage(page=1, perPageNum=20) {
            this.page = page;
            this.perPageNum = perPageNum;
            this.showPage = 10;
            this.pageStartNum = (page - 1) * perPageNum;
            this.endPage = Math.ceil(page / this.showPage) * this.showPage;
            this.startPage = this.endPage - this.showPage + 1;
            let tempEndPage = Math.ceil(this.totalCount / perPageNum);
            if ( this.endPage > tempEndPage) {
                this.endPage = tempEndPage;
            }
            this.prev = this.startPage != 1;
            this.next = this.endPage * perPageNum < this.totalCount; 
            this.pageList=[]; 
            for (let i = this.startPage; i <= this.endPage; i++) { 
                this.pageList.push(i);
            }
        }

        getListNumber(index) {
            return (this.page - 1) * this.perPageNum + index;
        }
        clickPrev() {
            this.setPage(this.page - 1);
            getApplicantList();
        }
        clickNext() {
            this.setPage(this.page + 1);
            getApplicantList();
        }
        clickPage(page) {
            this.setPage(page);
            getApplicantList();
        }
        clickSearch() {
            this.setPage();
            getApplicantList();
        }
        enter(e) {
            if (e.key === "Enter") {
                this.clickSearch();
            }
        }
    }

    let applicantList = [];
    let searchText = '';
    let searchCondition;
    let isPhoneNoPopup = false;
    let pageInfo = new PageInfo({});
    let viewPhoneNo;
    
    
    // const goToUserLogin = (userId) => {
    //     PRConnect.send("/api/Admin/setUserLogin", {userId}, data => {
    //         if (data.header.status === "success") {
    //             window.open("/main", "_blank");
    //         }
    //     });
    // }

    const clickPhoneNo = (phone) => {
        isPhoneNoPopup = true;
        viewPhoneNo = phone;
    }

	

    onMount(() => {
		getApplicantList();
    });

	const getApplicantList = () => {
		const eventId = currentRoute.namedParams.eventId;
		
		PRConnect.send("/api/Event/getApplicantList", {id: eventId, ...pageInfo, searchCondition, searchText}, data => {
			if (data.header.status === "success") {
				applicantList = data.result.applicantList;
				let totalCount = data.result.totalCount;
				pageInfo = new PageInfo({...pageInfo, totalCount});
			}
		});
	}
	 
	const clickAppovalFlag = (applicant) => {
		applicant.approvalFlag = applicant.approvalFlag === "Y" ? "N" : "Y";
		PRConnect.send("/api/Event/modifyApplicant", applicant, data => {
			if (data.header.status === "success") {
				console.log("applicant update success");
				getApplicantList();
			}
		});
	}
	
</script>
<div data-w-tab="Tab 6" class="w-tab-pane" class:w--tab-active={event.currentTab === "applicants"}>
	{#if event.isLoad}
	<div class="event-write">
		<div class="admin-title-text _2">이벤트 신청인 관리</div>
		<div class="event-main-image">
		<div class="admin-title-text">이벤트 신청인 목록</div>
		</div>
		<div>
			<div class="userList-wrapper">
				<div class="search-wrapper">
					<select bind:value={searchCondition}>
						<option value="email">이메일</option>
						<option value="id" selected>아이디</option>
						<option value="name">이름</option>
						<option value="phone">연락처</option>
					</select>
					<input type="text" bind:value={searchText} on:keydown={(e)=> pageInfo.enter(e)}>
					<button>
						검색
					</button>
				</div>
				<table>
					<tr class="tr-th">
						<th>순서</th>
						{#each event.receiveContent as content}
						<th class={RECEIVE_CONTENT[content]}>{RECEIVE_CONTENT[content]}</th>
						{/each}
						{#if event.eventType === "RECOMMEND"}
						<th class="table-name">추천인수</th>
						<th class="table-name">랭킹</th>
						<th class="table-join-date">제외여부</th>
						{/if}
					</tr>
				{#each applicantList as applicant, index (index)}
					<tr>
						<td>{pageInfo.getListNumber(index+1)}</td>
						{#each event.receiveContent as content}
						<td>{JSON.parse(applicant.privacyContent)[content] || "없음"}</td>
						<!-- <td>{JSON.parse(applicant.privacyContent).name || "없음"}</td>
						<td>{JSON.parse(applicant.privacyContent).email || "없음"}</td>
						<td class="pointer" on:click={() => clickPhoneNo(JSON.parse(applicant.privacyContent).phone || "없음")}>확인</td>
						<td>{JSON.parse(applicant.privacyContent).insta || "없음"}</td> -->
						{/each}
						{#if event.eventType === "RECOMMEND"}
						<td>{applicant.cnt || 0}</td>
						<td>{applicant.ranking || '없음'}</td>
						<td>
							<div class="toggle-button _2" on:click={()=> clickAppovalFlag(applicant)}>
								<div class="toggle" class:on={applicant.approvalFlag === "Y"}/>
								<div class="toggle-round" class:on={applicant.approvalFlag === "Y"}/>
							</div>
						</td>
						{/if}
						<!-- <td class="pointer" on:click={() => goToUserLogin(user.id)}>들어가기</td> -->
					</tr>
				{/each}
				</table>
				<div class="paging-wrapper">
					{#if pageInfo.prev}
					<div on:click={pageInfo.clickPrev}>◀︎</div>
					{/if}
					{#each pageInfo.pageList as page} 
					<div class="page-number" class:active={pageInfo.page === page} on:click={pageInfo.clickPage(page)}>{page}</div>
					{/each}
					{#if pageInfo.next}
					<div on:click={pageInfo.clickNext}>▶︎</div>
					{/if}
				</div>
			</div>
		</div>
	</div>
	{/if}
</div>
<!-- <div class="ava-popup" class:show={isPhoneNoPopup}>
    <div class="popup-layer withdraw">
        <div class="titile-text popup">
            <div class="h1 margin20">회원 정보</div>
            <div class="title-sub popup">{viewName} / {viewEmail}</div>
            <div class="title-sub popup view-phoneNo">{viewPhoneNo}</div>
        </div>
        <div class="popup-button">
            <a href="#" class="close-button w-button" on:click={()=>isPhoneNoPopup = false}>닫기</a>
        </div>
    </div>
</div> -->
<style>
    .userList-wrapper {
        margin: 0 auto;
        margin-top: 40px;
    }
    .active {
        font-weight: bold;
    }
    .page-number {
        cursor: pointer;
        display: inline-block;
        padding: 12px;
    }
    td {
        padding: 12px;
        text-align: center;
    }
    td, th { 
        min-width: 100px;
    }
    .tr-th {
        border-bottom: 2px solid darkgray;
    }
    .phone {
        min-width: 150px;   
    }

    .email {
        min-width: 250px;
    }
    .name {
        min-width: 150px;
    }

	.insta {
		min-width: 250px;
	}

    .paging-wrapper {
        display: flex;
        margin: 0 auto;
        width: max-content;
    }

    .search-wrapper {
        margin-bottom: 16px;
    }
    .popup-button {
        margin-top: 20px;
    }
    .view-phoneNo {
        font-size: 20px;
        font-weight: 700;
    }

	.toggle.on {
        border-color: #ff558d;
        border-radius: 30px;
        background-color: #ff558d;
    }

    .toggle {
        background-color: #999;
    }

	@media screen and (min-width: 1920px) {
		.event-write {
			width: 100%;
		}
	}
</style>